module.exports = __webpack_public_path__ + "img/flavor3.e4568523.svg";